export function makeUrlsClickable(text) {
    if (!text) return '';

    const urlRegex = /([^"']http[s]?:\/\/[^\s<]+[^"'])/g;
    const transformedText = text.replace(urlRegex, '<a href="$&" target="_blank" rel="noopener noreferrer">$&</a>');
    return transformedText;
}
